import i18next from 'i18next';

export const createQueryKeyFactory = <T extends string>(prefix: T) => {
  const createKey = <K extends ReadonlyArray<unknown>>(...args: K) => [prefix, ...args] as const;

  const locale = i18next.language;
  createKey.all = (locale?: string) => [prefix, locale] as const;
  createKey.detail = (id: string | number, locale?: string) => [prefix, 'detail', id, locale] as const;
  createKey.list = (filters?: Record<string, unknown>) => [prefix, 'list', filters, locale] as const;

  // Strapi-specific query keys
  createKey.search = (term: string, locale?: string) => [prefix, 'search', term, locale] as const;
  createKey.byCategory = (categoryId: number | string, locale?: string) =>
    [prefix, 'byCategory', categoryId, locale] as const;
  createKey.byAuthority = (authorityId: number | string, locale?: string) =>
    [prefix, 'byAuthority', authorityId, locale] as const;
  createKey.byZone = (zoneId: number | string, locale?: string) => [prefix, 'byZone', zoneId, locale] as const;
  createKey.pagination = (page: number, pageSize: number, locale?: string) =>
    [prefix, 'pagination', { page, pageSize }, locale] as const;

  return createKey;
};

export const queryKeys = {
  authorities: createQueryKeyFactory('authorities'),
  serviceCategories: createQueryKeyFactory('serviceCategories'),
  zones: createQueryKeyFactory('zones'),
  services: createQueryKeyFactory('services'),
  faqs: createQueryKeyFactory('faqs'),
  feedback: createQueryKeyFactory('feedback'),
  aboutUs: createQueryKeyFactory('aboutUs'),
  search: createQueryKeyFactory('search'),
};
